export default "__VITE_ASSET__$rlmtooZ__"